export default __webpack_public_path__ + "static/media/m_appDownload.27ac75ea.png";